export default {
    statisticSurveyBaseData: 'Daten',
    statisticSurveyPeriods: 'Erhebungszeiträume',
    statisticSurveyRights: 'Rechte',
    statisticSurveyActivities: 'Historie',
}